<script lang="ts">
import { storeToRefs } from "pinia"
import ConnexionForm from "../components/connexion/Form.vue"
import DefaultLayout from "../layouts/default.vue"
import { useEpciCommuneStore } from "../store"

export default {
    name: "Statistiques",
    components: {
        DefaultLayout,
        ConnexionForm,
    },
    setup() {
        useHead({
            title: "Larchiviste | Statistiques",
            meta: [
                { name: "description", content: "Statistiques" },
            ],
        })
        definePageMeta({
            middleware: ["auth"],
            layout: false,
        })
        const epciCommuneStore = useEpciCommuneStore()
        const { currentEpciCommune } = storeToRefs(epciCommuneStore)
        return {
            currentEpciCommune,
        }
    },
}
</script>

<template>
    <DefaultLayout>
        <!-- Login Form for Unauthenticated Users -->
        <v-card
            v-if="!$currentUser() || !$currentUser().k"
            class="mx-auto px-10 py-5 mb-10"
            elevation="8"
            max-width="500"
            rounded="lg"
        >
            <v-card-title class="pb-5 text-center">
                Connexion
            </v-card-title>
            <ConnexionForm />
        </v-card>
        <DashboardAdmin v-else-if="$currentUser().role === 'admin' && !currentEpciCommune?.id" />
        <DashboardUser v-else />
    </DefaultLayout>
</template>
